import useWidth from '../../../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../../../lang/LangEnum';
import { ActionEnum } from '../../../../../actions/types/orderActions.types';
import { OrderActionProps } from '../../../../../actions/types/orderActionsContext.types';
import { useOrderActionsContext } from '../../../../../contexts/OrderActions.context';
import { Order } from '../../../../../order.types';

interface GetOfflineAlertTextParams {
  isMobileWidth: boolean;
  isSmallWidth: boolean;
}

const getOfflineAlertText = ({ isMobileWidth, isSmallWidth }: GetOfflineAlertTextParams) => {
  if (isMobileWidth) {
    return LangEnum.OFFLINE_ALERT_TO_LIST_MOBILE;
  }

  if (isSmallWidth) {
    return LangEnum.OFFLINE_ALERT_TO_LIST_SMALL;
  }

  return LangEnum.OFFLINE_ALERT_TO_LIST;
};

const useOrderObjectOfflineBanner = (order: Order) => {
  const { mobileWidth: isMobileWidth, smallWidth: isSmallWidth } = useWidth();
  const { onClickOrderAction } = useOrderActionsContext();

  const downloadBackup = () => {
    onClickOrderAction(ActionEnum.EXPORT_ORDER, OrderActionProps.orderToProps(order));
  };

  return {
    alertText: getOfflineAlertText({ isMobileWidth, isSmallWidth }),
    isCompact: isMobileWidth,
    downloadBackup,
  };
};

export default useOrderObjectOfflineBanner;
